import React, { Component } from 'react';
import GroupMuteButton from 'components/mix/GroupMuteButton.js';
import GroupThumbnailPart from 'components/mix/GroupThumbnailPart.js';
import {THUMBNAIL_WIDTH} from 'components/mix/constants.js';

class GroupThumbnail extends Component {

    constructor(props) {
        super(props);
    }

    onClickTrack(track) {
        if (this.props.selectedTrack === track.trackNumber &&
           this.props.group.tracks.length > 1) {
            this.props.onSelectTrack(undefined);
        } else {
            this.props.onSelectTrack(track);
        }
    }

    render() {
        let group = this.props.group;

        // we want to show a thumbnail for the group
        // but split vertically between the # of tracks w/in the group.
        let size = group.tracks.length;

        // figure out the width of each track slice within
        let partWidth = THUMBNAIL_WIDTH / size;

        return (
            <div>
              <GroupMuteButton partWidth={partWidth} group={group}/>
              <div
                className="group-thumbnail">
                {group.tracks.map(
                  track =>
                      <GroupThumbnailPart
                        key={"group-thumbnail-track-" + track.trackNumber}
                        onDraggingTrack={this.props.onDraggingTrack}
                        trackDragging={this.props.trackDragging}
                        onGroupsChanged={this.props.onGroupsChanged}
                        renders={this.props.renders}
                        groups={this.props.groups}
                        onClickTrack={(track) => this.onClickTrack(track)}
                        numParts={group.tracks.length}
                        isSelectedGroup={this.props.isSelectedGroup}
                        selectedTrack={this.props.selectedTrack}
                        track={track}
                        partWidth={partWidth}
                        group={group}/>
                       )}
            </div>
          </div>
        );
    }
}

export default GroupThumbnail;
